<template>
<div>
    <!-- Modal Component -->
    <b-modal v-model="openModal" title="Corrective Action Details" size="lg" :ok-only="true" ok-title="OK" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="actionModal" :no-close-on-backdrop="true" scrollable>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <template v-else>
            <div class="row">
                <div class="col-md-6">
                    <div class="card mb-4">
                        <h6 class="card-header">
                            <span class="pull-right">
                                <router-link :to="`/corrective-actions/complete/${corrective_action_id}`" class="btn btn-xs btn-success">
                                    <i class="fa fa-check-square"></i> Mark Completed
                                </router-link>
                                <router-link :to="`/corrective-actions/edit/${corrective_action_id}`" class="btn btn-xs btn-secondary">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/corrective-actions/delete/${corrective_action_id}`" class="btn btn-xs btn-danger">
                                    <i class="fa fa-trash"></i> Delete
                                </router-link>
                            </span>
                        </h6>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Status</div>
                                <span class="ca-status">
                                    <label :class="`badge badge-${action['status'].status_id ? action['status'].status_color : ''}`">
                                        {{ action['status'].status_id ? action['status'].status_name : '--' }}
                                    </label>
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Source</div>
                                <div>{{ action.corrective_source_id ? action['source'].source_name : '' }}</div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Location</div>
                                <div>{{ action.location }}</div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Created By</div>
                                <div>{{ action['creator'].FirstName }} {{ action['creator'].LastName }}</div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Assigned To</div>
                                <div>{{ action.assignee_name  }}</div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Subcontractor</div>
                                <div>{{ action.subcontractor }}</div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Completed By</div>
                                <div v-if="action['completer']">{{ action['completer'].FirstName }} {{ action['completer'].LastName }}</div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Created Date</div>
                                <div><span class="ca-completed-at">{{ action.created_at_formatted }}</span></div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Due Date</div>
                                <div><span class="ca-completion-time">{{ action.due_date }}</span></div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Completed Date</div>
                                <div><span class="ca-completion-time">{{ action.completed_at_formatted }}</span></div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Time to Completion</div>
                                <div><span class="ca-completion-time">{{ action.time_to_completion }}</span></div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card mb-4">
                        <h6 class="card-header">
                            Details
                        </h6>
                        <div class="card-body">
                            {{ action.detail }}
                        </div>
                    </div>

                    <div class="card mb-4">
                        <h6 class="card-header">
                            Completed Note
                        </h6>
                        <div class="card-body">
                            <span class="ca-completed-comment">{{ action.completed_detail }}</span>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <h6 class="card-header">
                            Files &amp; Photots
                        </h6>
                        <div class="card-body">
                            <file-list :files="files" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</div>
</template>

<script>
export default {

    data: function() {
        return {
            openModal: false,
            loading: true,
            errors: {},
            files: [],
            action: {},
            corrective_action_id: ''
        }
    },

    methods: {

        handleHide(bvEvt) {
            //debugging
            if (this.$root.debug) {
                //console.log('Hiding Modal');
            }
        },

        handleHidden(bvEvt) {
            //Reset the values
            this.result = {};
            this.errors = {};
            this.files = [];
        },

        handleOk: function(bvEvt) {

            //Stops the modal from closing
            //bvEvt.preventDefault();

            //Show loading?

            //Do it
            //this.saveResult();
        },

        showModal() {
            //Show it
            this.openModal = true;
        },

        setModel(result) {
            this.action = JSON.parse(JSON.stringify(result));
            this.corrective_action_id = this.action['corrective_action_id'];
            this.loading = false;
        },

    },

    mounted() {
        //Set the height
        //this.$refs.actionModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';

        //Get the resources
        // this.getFormResources();
    }
}
</script>
